/*
* Product Add-ons Custom Element
*/

if (typeof ProductAddons === "undefined") {
  class ProductAddons extends HTMLElement {
    constructor() {
      super();

      this.addOns = this.querySelectorAll('.product-addon');
      this.addOns.forEach(
        (addOn) => addOn.addEventListener('click', this.onProductAddOnClick.bind(this))
      );

      this.initPurchaseEventListeners();
      this.initCartEventListeners();
    }

    initPurchaseEventListeners() {
      const addOns = this.addOns;

      $(document).on("click", ".product-purchase--addons .c-product-purchase__radio", function(e){
        let atcPrice = $(this).parents('.c-product-purchase__form').find('[js-price-output]');
        let purchaseType = $(this).attr('data-purchase-type');
        let monthlyPrice = parseFloat($(this).attr('data-monthly-price'));
        let totalPrice = monthlyPrice;
        let monthSymbol = '<small>/mo</small>';

        if(purchaseType == "onetime") {
          //show onetime price only
          addOns.forEach((addOn) => {
            let extraCost = parseFloat(addOn.dataset.onetimePrice)
            $(addOn).find('.addon-price').text(`$${extraCost}`)
            $(addOn).find('.onetime-hide').hide();
            monthSymbol = '';
            //add extra cost of active addons
            if(addOn.classList.contains('active')){
              totalPrice += extraCost;
            }
          });
        }
        else {
          addOns.forEach((addOn) => {
            //determine if monthly or quarterly, and then show correct monthly extra cost per item which originates from metafields
            let moPrice = parseFloat(addOn.dataset['1moPrice']);
            let extraCost;
            if(purchaseType == "monthly"){
              extraCost = parseFloat(addOn.dataset['1moExtraCost']);
            }
            else if(purchaseType == "quarterly"){
              extraCost = parseFloat(addOn.dataset['3moExtraCost']);
            }
            else if(purchaseType == "semiannually"){
              //TODO: Handle this in future. For now, exit function
              return false;
            }
            let savingsPercent = (((moPrice - extraCost) / moPrice) * 100).toFixed();
            addOn.querySelector('.addon-price').innerText = `$${extraCost.toFixed(2).replace(/\.00$/, '')}`;
            addOn.querySelector('.addon-savings').innerText = `${savingsPercent}`;
            $(addOn).find('.onetime-hide').show();
            //add extra cost of active addons
            if(addOn.classList.contains('active')){
              totalPrice += extraCost
            }
          })
        }

        //update total atc price if different than buy box price
        let displayPrice = monthlyPrice;
        if(totalPrice > monthlyPrice) {
          displayPrice = totalPrice;
        }
        atcPrice.html(` — $${Shopify.formatMoney(displayPrice * 100, '{{amount}}').replace('.00','')}${monthSymbol}`)

      });
    }

    initCartEventListeners() {
      const addOns = this.addOns;

      //if cart does not contain the addon item, we should unhide it
      document.addEventListener("cart:item:removed", (e) => {
        let itemsInCart = e.detail?.items.map(item => item.variant_id.toString());
        if (itemsInCart) {
          addOns.forEach(addOn => {
            let monthlyId = addOn.dataset.variantId.toString();
            let quarterlyId = addOn.dataset.variantIdQuarterly.toString();

            //item not in cart
            if (!itemsInCart.includes(monthlyId) && !itemsInCart.includes(quarterlyId)) {
              addOn.classList.remove('hidden');
              addOn.dataset.addonInCart = false;
            };
          });
        }
      });

      //if add-on item is added to cart, we should update its attributes
      document.addEventListener("cart:item:added", (e) => {
        let itemsAddedToCart = e.detail?.items.map(item => item.variant_id.toString());
        if (itemsAddedToCart) {
          addOns.forEach(addOn => {
            let monthlyId = addOn.dataset.variantId.toString();
            let quarterlyId = addOn.dataset.variantIdQuarterly.toString();

            //item in cart
            if (itemsAddedToCart.includes(monthlyId) || itemsAddedToCart.includes(quarterlyId)) {
              addOn.classList.add('hidden');
              addOn.dataset.addonInCart = true;
            };
          });
        }
      });
    }


    onProductAddOnClick(event) {

      if (event.target.matches('a[href]')){
        return
      }else{
        event.preventDefault()
      }


      const $target = $(event.target);
      const $addOn = $target.parents('.product-addon');

      //make addon active
      $addOn.toggleClass('active');

      //show secondary addon if clicking the first addon
      if($addOn.hasClass('primary-addon')){
        let secondaryAddons = $addOn.get(0).parentElement.querySelectorAll('.product-addon.secondary-addon');
        secondaryAddons.forEach(addon => {
          //only show secondary if it's not already in cart
          let addonCartState = addon.dataset.addonInCart;
          if (addonCartState !== "true" && addonCartState !== true) {
            addon.classList.remove('hidden');
          }
        });
      }

      //get monthly price of main product
      const $selectedPurchase = $target.parents('.c-product-purchase__form').find('.c-product-purchase__radio:checked');
      const atcPrice = $target.parents('.c-product-purchase__form').find('[js-price-output]');
      let purchaseType = $selectedPurchase.attr('data-purchase-type');
      let monthlyPrice = parseFloat($selectedPurchase.attr('data-monthly-price'));
      let totalPrice = monthlyPrice;
      let monthSymbol = '<small>/mo</small>';

      //add up extra cost for each active addon
      this.addOns.forEach((addOn) => {
        if(!addOn.classList.contains('active')) return false;

        let extraCost;

        if(purchaseType == "onetime"){
          extraCost = parseFloat(addOn.dataset.onetimePrice)
          monthSymbol = '';
        }
        else if(purchaseType == "monthly"){
          extraCost = parseFloat(addOn.dataset['1moExtraCost']);
        }
        else if(purchaseType == "quarterly"){
          extraCost = parseFloat(addOn.dataset['3moExtraCost']);
        }
        totalPrice += extraCost
      })

      //update total atc price
      atcPrice.html(` — $${Shopify.formatMoney(totalPrice * 100, '{{amount}}').replace('.00','')}${monthSymbol}`)

    }

  }
  customElements.get('product-addons') || customElements.define('product-addons', ProductAddons);
}